import { Component, input, output } from '@angular/core';
import { webDtos } from '@vectronic/openApi-customer';
import { NotificationTableComponent } from '../notification-table/notification-table.component';

@Component({
  selector: 'table-notifications-details',
  templateUrl: './notifications-details.component.html',
  styleUrls: ['./notifications-details.component.scss'],
  imports: [NotificationTableComponent],
})
export class NotificationsDetailsComponent {
  collarId = input<number>();
  isAtLeastDataManager = input<boolean>();
  rules = input<webDtos.NotificationRule[]>();
  deleteRuleNotification = output<webDtos.NotificationRule>();
  addNotificationModal = output<number[]>();

  onAddNotification() {
    this.addNotificationModal.emit([this.collarId()]);
  }
}
